import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { LogLevel } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { CacheControlInterceptor } from '@aifs-shared/net/cache-control.interceptor';
import { DefaultRequestOptions } from '@aifs-shared/net/default-request-options.service';
import { GlobalErrorHandler } from '@aifs-shared/errors/error-handler';
import { HttpErrorInterceptor } from '@aifs-shared/errors/http-error-handler';
import { WindowRef } from '@aifs-shared/framework/window-ref';
import { AmazonS3RequestOptions } from '@aifs-shared/net/amazon-s3-request-options';

export function loggerCallback(logLevel: LogLevel, message: string) {
    //console.log(message);
}


export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheControlInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DefaultRequestOptions,
            multi: true
        },
        // {
        //     provide: ErrorHandler,
        //     useClass: GlobalErrorHandler
        // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AmazonS3RequestOptions,
            multi: true
        },
        WindowRef,
    ]
};
